// extracted by mini-css-extract-plugin
module.exports = {"copyrights":"footer-module--copyrights--mO9_q","sasho":"footer-module--sasho--2jO1f"};